import axiosInstance from "../Services/axiosInstance";

const salesStatsService = {
    fetchDailyLabStats: async () => {
        try {
            const response = await axiosInstance.get('sales/daily-lab-stats');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    fetchDailyRadiologyStats: async () => {
        try {
            const response = await axiosInstance.get('sales/daily-radiology-stats');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },
};

export default salesStatsService;